import { useEffect, useRef } from "react";
import { parseBarLines } from "./parse";

interface GaugeRingsProps {
  content: string;
}

const RING_SIZE = 60;
const RING_RADIUS = 24;
const CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

export function GaugeRings({ content }: GaugeRingsProps) {
  const items = parseBarLines(content);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Delay stroke animation to let entrance animation play first
    const timer = setTimeout(() => {
      containerRef.current?.classList.add("cx-gauge--ready");
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  if (items.length === 0) return null;

  const total = items.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="cx-gauge" ref={containerRef}>
      {items.map((item, i) => {
        const pct = total > 0 ? Math.round((item.value / total) * 100) : 0;
        const filled = (pct / 100) * CIRCUMFERENCE;

        return (
          <div key={i} className="cx-gauge-item">
            <div className="cx-gauge-ring">
              <svg width={RING_SIZE} height={RING_SIZE} viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}>
                <circle
                  className="cx-gauge-ring-bg"
                  cx={RING_SIZE / 2}
                  cy={RING_SIZE / 2}
                  r={RING_RADIUS}
                />
                <circle
                  className="cx-gauge-ring-fill"
                  cx={RING_SIZE / 2}
                  cy={RING_SIZE / 2}
                  r={RING_RADIUS}
                  strokeDasharray={`${filled} ${CIRCUMFERENCE}`}
                />
              </svg>
              <span className="cx-gauge-pct">{pct}%</span>
            </div>
            <div className="cx-gauge-label">{item.label}</div>
          </div>
        );
      })}
    </div>
  );
}
